import { useQuery } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';

import Loading from './components/feedback/loading.jsx';
import { msCatalystApi } from './services/api/ms-catalyst-api.js';
import { authState } from './services/state/auth-state.jsx';
import { CATALYST_USER_ROLES } from './utils/constants.js';

import router from './router/index.js';

import './styles/globals.css';

function App() {
  const queryLoggedInUser = useQuery({
    queryKey: ['logged-in'],
    queryFn: async () => {
      const { data: loggedInUserRes } =
        await msCatalystApi.post('/auth/logged-in');

      authState.user = loggedInUserRes.data;
      authState.isAdmin =
        loggedInUserRes.data.details.role === CATALYST_USER_ROLES.admin;

      return loggedInUserRes.data;
    },
  });

  return (
    <>
      {queryLoggedInUser.isLoading ? (
        <div className="flex min-h-[100svh] items-center justify-center">
          <Loading />
        </div>
      ) : (
        <RouterProvider router={router} />
      )}
    </>
  );
}

export default App;
